import React, { Component } from 'react';
import { Popover, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Modal, Alert } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import LoadingSpinner from '../components/LoadingSpinner';
import copyToClipboard from '../utils/CopyToClipboard';

// To handle requests
import PoliciesAPI from '../utils/PoliciesAPI';

// External
import Reactable from 'reactable';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';

// Setting reactable values instead of regular table
const Table = Reactable.Table;
const Thead = Reactable.Thead;
const Th = Reactable.Th;
const Tr = Reactable.Tr;
const Td = Reactable.Td;

class DisplayPoliciesList extends Component {
    constructor() {
        super();
        this.state = {
            copiedState: false,
        };
    }

    copyArnToClipboard(value) {
        const success = copyToClipboard(value);
        this.setCopied(success);
    }

    setCopied(success) {
        if (success) {
            this.setState({ copiedState: true });
            setTimeout(() => {
                this.setState({ copiedState: false });
            }, 2000);
        }
    }

    handleAction(arn) {
        this.props.buttonAction(arn);
    }

    getPolicyRow(policy) {
        const actGroup =
        <div className="btn-group btn-group-xs policy-actions">
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={
              <Tooltip id="policyActionbtn">
                {this.props.buttonLabel}
              </Tooltip>
          }>
            <button
              onClick={this.handleAction.bind(this,
                this.props.longerArnLabel
              ? policy.PolicyArn : policy.Arn)}
              className="btn btn-primary btn-xs"
              style={brandingStyles.buttons.primary}
            >
              <i className={`fa ${this.props.buttonIcon}`}/>
            </button>
          </OverlayTrigger>
        </div>;

        const arnPopover = (
            <Popover
              id="popover-user-arn-value"
              title="Amazon Resource Name (ARN)"
            >
              <p style={{ wordWrap: 'break-word' }}>
                  {this.props.longerArnLabel
                  ? policy.PolicyArn : policy.Arn}
              </p>
              <hr />
              <strong>
                {this.state.copiedState
                  ? 'Copied' : 'Click to copy to clipboard'}
              </strong>
            </Popover>
        );

        const arnEyeIcon = (
            <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="right"
                overlay={arnPopover}>
                    <i
                      className="fa fa-eye"
                      style={Object.assign(
                          {
                              fontSize: '18px',
                              cursor: 'pointer',
                          },
                        brandingStyles.mainColor
                      )}
                      onClick={this.copyArnToClipboard
                        .bind(this, this.props.longerArnLabel
                          ? policy.PolicyArn : policy.Arn)}
                    />
            </OverlayTrigger>
        );

        return (
            <Tr
              key={this.props.longerArnLabel
                ? policy.PolicyArn : policy.Arn}
              className="policy-row"
              style={brandingStyles.fontColor}
            >
                <Td
                  column="PolicyName"
                  data={policy.PolicyName}
                  className="bold padding-l-25"
                >
                    {policy.PolicyName}
                </Td>
                <Td column="PolicyArn">
                  {arnEyeIcon}
                </Td>
                <Td column="Actions">
                  {actGroup}
                </Td>
            </Tr>
        );
    }

    render() {
        let policiesList;
        if (this.props.policies
          && this.props.policies[this.props.currentIndex]) {
            policiesList = this.props.policies[this.props.currentIndex].map(
              policy => this.getPolicyRow(policy)
            );
        }

        const arnPopover = (
            <Popover id="popover-policy-arn" title="Amazon Resource Name (ARN)">
                <p>
                    {'Each IAM policy has a unique ARN with the format: '}
                </p>
                <p>
                    {'arn:<partition>:<service>::<account-id>:'}
                    {'<resourcetype/resource>'}
                </p>
            </Popover>
        );

        const arnHelpIcon = (
            <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="right"
                overlay={arnPopover}>
                    <i className="fa fa-question-circle-o"></i>
            </OverlayTrigger>
        );


        const table = <Table
          className="table table-striped"
          id="table"
          sortable={[
              'PolicyName',
          ]}
        >
            <Thead>
                <Th column="PolicyName" className="padding-l-25">
                    <strong className="name-header">Name</strong>
                </Th>
                <Th column="PolicyArn">
                    <strong className="name-header">ARN</strong>
                    {' '}{arnHelpIcon}
                </Th>
                <Th column="Actions">
                    <strong className="name-header">Actions</strong>
                </Th>
            </Thead>
            {policiesList}
        </Table>;

        const prevDisabled = this.props.currentIndex === 0;
        const nextDisabled = this.props.currentIndex === this.props.maxIndex;

        const pagerInstance = (
          <ul className="pager padding-l-15 padding-r-15">
            <li
              className={prevDisabled ? 'previous disabled' : 'previous'}
            >
              <a
                className="clickable"
                onClick={this.props.prevPageFunc}
                style={brandingStyles.buttons.primary}
              >&larr;</a>
            </li>
            <li
              className={nextDisabled ? 'next disabled' : 'next'}
            >
              <a
                className="clickable"
                onClick={this.props.nextPageFunc}
                style={brandingStyles.buttons.primary}
              >&rarr;</a>
            </li>
          </ul>
        );

        return (
          <div>
              {table}
              {pagerInstance}
          </div>
        );
    }
}

DisplayPoliciesList.propTypes = {
    nextPageFunc: PropTypes.func.isRequired,
    prevPageFunc: PropTypes.func.isRequired,
    policies: PropTypes.array.isRequired,
    currentIndex: PropTypes.number.isRequired,
    maxIndex: PropTypes.number.isRequired,
    longerArnLabel: PropTypes.bool,
    buttonIcon: PropTypes.string.isRequired,
    buttonLabel: PropTypes.string.isRequired,
    buttonAction: PropTypes.func.isRequired,
};


class ManageUserPoliciesButton extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            errorText: null,
            modalErrorAlert: '',
            dataLoaded: false,
            nbItems: 15,
            attached: {
                policies: [],
                currentIndex: 0,
                maxIndex: -1,
                marker: null,
            },
            available: {
                policies: [],
                currentIndex: 0,
                maxIndex: -1,
                marker: null,
            },
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handlePreviousPageAttached
        = this.handlePreviousPageAttached.bind(this);
        this.handleNextPageAttached = this.handleNextPageAttached.bind(this);
        this.handlePreviousPageAvailable
        = this.handlePreviousPageAvailable.bind(this);
        this.handleNextPageAvailable = this.handleNextPageAvailable.bind(this);
        this.handleUserAction = this.handleUserAction.bind(this);
        this.handleAttach = this.handleAttach.bind(this);
        this.handleDetach = this.handleDetach.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
        this.refresh();
    }

    // removing attached policies from available policies list
    trimAvailable(values) {
        let existing = [];
        const available = values;

        for (let i = 0; i < this.state.attached.policies.length; i++) {
            const tmp = this.state.attached.policies[i].map(
              policy => policy.PolicyArn
            );
            existing = existing.concat(tmp);
        }

        for (let i = 0; i < available.length; i++) {
            const tmp = available[i];
            const newPage = [];
            for (let j = 0; j < tmp.length; j++) {
                if (tmp[j].IsAttachable
                  && existing.indexOf(tmp[j].Arn) === -1) {
                    newPage.push(tmp[j]);
                }
            }
            available[i] = newPage;
        }
        return available;
    }

    handleUserAction() {
        this.setState({
            attached: {
                policies: [],
                currentIndex: 0,
                maxIndex: -1,
                marker: null,
            },
            available: {
                policies: [],
                currentIndex: 0,
                maxIndex: -1,
                marker: null,
            },
        });
        this.refresh();
    }

    refresh() {
        this.setState({ dataLoaded: false });
        // Retrieving attached policies
        PoliciesAPI.getUserPolicies(
          this.props.username,
          this.state.nbItems,
          this.state.attached.marker
        ).then(res => {
            const policiesPages = this.state.attached.policies;
            policiesPages[this.state.attached.currentIndex]
            = res.attachedPolicies;
            this.setState({
                attached: {
                    policies: policiesPages,
                    marker: res.marker,
                    maxIndex: res.marker ? -1
                    : this.state.attached.currentIndex,
                    currentIndex: this.state.attached.currentIndex,
                },
            }, () => {
                // Retrieving available policies
                PoliciesAPI.getPolicies(
                this.state.nbItems,
                this.state.available.marker
                ).then(res => {
                  const policiesPagesAvailable = this.state.available.policies;
                  policiesPagesAvailable[this.state.available.currentIndex]
                  = res.policies;
                  this.setState({
                      dataLoaded: true,
                      available: {
                          policies: this.trimAvailable(policiesPagesAvailable),
                          marker: res.marker,
                          maxIndex: res.marker ? -1
                          : this.state.available.currentIndex,
                          currentIndex: this.state.available.currentIndex,
                      },
                  });
              });
            });
        });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            showModal: false,
            modalErrorAlert: '',
            dataLoaded: false,
        });
    }

    handlePreviousPageAttached() {
        this.setState({
            attached: Object.assign(
                {},
                this.state.attached,
                {
                    currentIndex: this.state.attached.currentIndex - 1,
                }
            ),
        });
    }

    handleNextPageAttached() {
        const currentIndex = this.state.attached.currentIndex;
        this.setState({
            attached: Object.assign(
                {},
                this.state.attached,
                {
                    currentIndex: this.state.attached.currentIndex + 1,
                }
            ),
        });
        if (currentIndex + 1 === this.state.attached.policies.length) {
            this.refresh();
        }
    }

    handlePreviousPageAvailable() {
        this.setState({
            available: Object.assign(
                {},
                this.state.available,
                {
                    currentIndex: this.state.available.currentIndex - 1,
                }
            ),
        });
    }

    handleNextPageAvailable() {
        const currentIndex = this.state.available.currentIndex;
        this.setState({
            available: Object.assign(
                {},
                this.state.available,
                {
                    currentIndex: this.state.available.currentIndex + 1,
                }
            ),
        });
        if (currentIndex + 1 === this.state.available.policies.length) {
            this.refresh();
        }
    }

    handleAttach(arn) {
        this.setState({ dataLoaded: false });
        PoliciesAPI.attachToUser(arn, this.props.username)
        .then(() => {
            this.handleUserAction();
        })
        .catch(() => {
            this.setState({ dataLoaded: true });
        });
    }

    handleDetach(arn) {
        this.setState({ dataLoaded: false });
        PoliciesAPI.detachFromUser(arn, this.props.username)
        .then(() => {
            this.handleUserAction();
        })
        .catch(() => {
            this.setState({ dataLoaded: true });
        });
    }

    render() {
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger" className="margin-t-15">
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        const loadedComponent = (
          <div className="row">
            <div className="col-md-6">
              <h4>
                <i className="fa fa-gear"/>
                &nbsp;
                Available
              </h4>
              <DisplayPoliciesList
                nextPageFunc={this.handleNextPageAvailable}
                prevPageFunc={this.handlePreviousPageAvailable}
                currentIndex={this.state.available.currentIndex}
                maxIndex={this.state.available.maxIndex}
                policies={this.state.available.policies}
                longerArnLabel={false}
                buttonIcon="fa-link"
                buttonLabel="Attach policy"
                buttonAction={this.handleAttach}
              />
            </div>
            <div className="col-md-6">
              <h4>
                <i className="fa fa-link"/>
                &nbsp;
                Currently attached
              </h4>
              <DisplayPoliciesList
                nextPageFunc={this.handleNextPageAttached}
                prevPageFunc={this.handlePreviousPageAttached}
                currentIndex={this.state.attached.currentIndex}
                maxIndex={this.state.attached.maxIndex}
                policies={this.state.attached.policies}
                longerArnLabel={true}
                buttonIcon="fa-times"
                buttonLabel="Detach policy"
                buttonAction={this.handleDetach}
              />
            </div>
          </div>
        );


        return (
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={
              <Tooltip id="deleteUserTooltip">
                Manage {this.props.username} policies
              </Tooltip>
          }>
            <button
              className="btn btn-primary btn-xs list-user-policies-btn"
              style={brandingStyles.buttons.primary}
              onClick={this.openModal}
            >
                <i className="fa fa-list"></i>
                <Modal
                  show={this.state.showModal}
                  onHide={this.closeModal}
                  bsSize="large"
                >
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-edit"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            {this.props.username} policies
                            <span>&nbsp;</span>
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                      {
                        this.state.dataLoaded
                        ? loadedComponent
                        : <LoadingSpinner />
                      }
                      {errorAlert}
                    </Modal.Body>
                    <Modal.Footer style={brandingStyles.backgrounds.panel}>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.closeModal}>
                            Close
                        </button>
                    </Modal.Footer>
                </Modal>
            </button>
          </OverlayTrigger>
        );
    }

}

ManageUserPoliciesButton.propTypes = {
    username: PropTypes.string.isRequired,
    callback: PropTypes.func,
};

export default ManageUserPoliciesButton;



/** WEBPACK FOOTER **
 ** ./src/components/ManageUserPoliciesButton.js
 **/